export const voices = [
  {
    name: "追瓜日常",
    role: "连续追踪用户",
    color: "primary",
    text: "最舒服的一点是时间线。以前一个瓜要吃三天才知道来龙去脉，现在打开追踪页，谁先动的手、哪天改的口径，一眼就看完了。",
  },
  {
    name: "夜猫子阿哲",
    role: "娱乐圈关注者",
    color: "accent",
    text: "可信度标注真的很实用。实锤和待证实分开看，省得被一些捕风捉影的内容带偏，这一点比很多同类型站点都做得好。",
  },
  {
    name: "小禾同学",
    role: "内容运营从业者",
    color: "secondary",
    text: "写得很克制，涉及具体的人一律化名，只写公开动作。做选题的时候我会来这里看时间线怎么理，思路很清楚。",
  },
  {
    name: "听风者K",
    role: "长期读者",
    color: "primary",
    text: "订阅了爆料速递，每天一封，不刷屏也不废话。哪天有事就点进去看，没事就划过去，这种节奏刚刚好。",
  },
];